<div *ngIf="loading$ | async" class="spinner-container">
	<mat-spinner></mat-spinner>
</div>
